(ns app.front.view.admin.freshdesk
  "Admin UI for managing downloaded Freshdesk articles."
  (:require [app.front.ui :as ui]
            [app.front.ui.sortable-table :as sortable-table]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

;; Events

(rf/reg-event-db ::set-articles
  (fn [db [_ _ response]]
    (assoc db ::articles (:articles response)
           ::article-count (:count response))))

(rf/reg-event-fx ::load-articles
  (fn [_ _]
    {:comm/command {:command    :admin/list-freshdesk-articles
                    :method     :get
                    :on-success [::set-articles]}}))

(rf/reg-event-fx ::delete-all-articles
  (fn [{:keys [db]} _]
    {:db           (assoc db ::deleting? true)
     :comm/command {:command          :admin/delete-all-freshdesk-articles
                    :method           :post
                    :on-success       [::set-articles {:articles [] :count 0}]
                    :notify           {:success "Freshdesk articles deleted."}
                    :finally-dispatch [::delete-all-articles.done]}}))

(rf/reg-event-db ::delete-all-articles.done
  (fn [db _]
    (dissoc db ::deleting?)))

;; Subscriptions

(rf/reg-sub ::articles :-> ::articles)
(rf/reg-sub ::article-count :-> ::article-count)
(rf/reg-sub ::deleting? :-> ::deleting?)

;; Components

(defn articles-table []
  (let [tr       (<sub [:tr])
        articles (<sub [::articles])]
    [sortable-table/table
     {:id      "freshdesk-articles"
      :tr      tr
      :cols    [["Title" :title {:sorting true}]
                ["Freshdesk ID" :id {:sorting true}]]
      :items   articles
      :id-func :id}]))

(defn delete-section []
  (let [tr        (<sub [:tr])
        articles  (<sub [::articles])
        deleting? (<sub [::deleting?])]
    [:div.mb-6
     [:p.text-sm.text-gray-600.mb-4
      "Delete all downloaded Freshdesk articles from Datomic, Cloud Storage (HTML files), and PostgreSQL (RAG embeddings). This action cannot be undone."]
     (if deleting?
       (cc/inline-loading {:description "Deleting articles..."})
       [ui/modal-confirmation-button
        {:trigger-button-opts {:kind     :danger
                               :icon     i/warning
                               :size     :field
                               :disabled (empty? articles)}
         :trigger-button-text "Delete all articles"
         :on-yes-click        #(>evt [::delete-all-articles])
         :tr                  tr
         :id                  "delete-all-freshdesk-articles"}
        (str "Are you sure you want to delete all " (count articles) " Freshdesk articles? "
             "This will remove them from Datomic, Cloud Storage, and the RAG embeddings database.")])]))

(defn freshdesk-panel []
  (r/create-class
    {:component-did-mount
     (fn [_] (>evt [::load-articles]))

     :reagent-render
     (fn []
       (let [article-count (<sub [::article-count])]
         [:section
          [:div.mb-4
           [:h2.text-xl.font-semibold "Freshdesk Articles"]]
          [:p.mb-4 (str "Currently " (or article-count 0) " Freshdesk articles downloaded.")]
          [delete-section]
          [:div.mt-6
           [:h3.mb-2 "Downloaded articles"]
           [articles-table]]]))}))
